import { useState } from "react";
import axios from "axios";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Feed from "./components/Feed/Feed";
import arrayMove from "array-move";
import "./App.css";

/**
 * TODO:
 * - add sorting with: https://github.com/clauderic/react-sortable-hoc
 */

function App() {
  const [formErrors, setFormErrors] = useState("");
  const [tags, setTags] = useState("");
  const [feeds, setFeeds] = useState([
    {
      name: "Category Icons",
      categoryId: "category",
      results: [],
      htmlString: "",
      isCategories: true,
      articleCount: 0,
    },
    {
      name: "ASPPH News",
      categoryId: 2,
      results: [],
      htmlString: "",
      showExcerpt: true,
      articleCount: 0,
    },
    {
      name: "Members in the News",
      categoryId: 6,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
    {
      name: "School & Program Updates",
      categoryId: 8,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
    {
      name: "Global Action",
      categoryId: 4,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
    {
      name: "Faculty Staff & Honors",
      categoryId: 3,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
    {
      name: "Member Research & Reports",
      categoryId: 5,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
    {
      name: "Students & Alumni Achievements",
      categoryId: 9,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
    // {
    //   name: "Events",
    //   categoryId: 41,
    //   results: [],
    //   htmlString: "",
    //   isEvents: true,
    //   articleCount: 0,
    // },
    {
      name: "Partner News",
      categoryId: 7,
      results: [],
      htmlString: "",
      articleCount: 0,
    },
  ]);

  const countArticlesInFeed = (feedIndex) => {
    let newFeeds = [...feeds];
    let categoryArticleCount = 0;
    newFeeds[feedIndex].results.forEach((post) => {
      if (post.hidden !== true) {
        categoryArticleCount++;
      }
    });
    newFeeds[feedIndex].articleCount = categoryArticleCount;
    // console.log("new count: " + categoryArticleCount);
    setFeeds(newFeeds);
  };

  const buildHtmlString = (
    feedResults,
    withExcerpt = false,
    isEvents = false,
    isCategories = false
  ) => {
    let feedTotals = feeds.forEach((feed, index) => {
      countArticlesInFeed(index);
    });
    let categoryIconCount = 1;
    let aspphNewsCount = 1;
    let schoolProgCount = 1;
    let studentAlumniCount = 1;
    let globalActionCount = 1;
    let facultyStaffCount = 1;
    let articleHtmlStrings = feedResults
      .map((post, index) => {
        // console.log(post);
        if (post.hidden !== true && post.categoryId === "category") {
          let categoryIconTotal = feeds[0].articleCount;
          // console.log(categoryIconTotal);
          const theName = post.name;
          const theImgUrl = post.imgUrl;
          const theAnchorLink = post.anchorLink;
          // HTML snippet options
          const fourInARowSpotOne = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody><tr>
            <td class="paddingRightLeft10" align="center" valign="top">
              <table class="widthFull" width="580" style="width:580px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="left" valign="top">
                    <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                      <tbody><tr>
        
                        <td width="50%" align="center" valign="top">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
                            </tr>
                          </tbody></table>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
                              </td>
                            </tr>
                          </tbody></table>
                        </td>`;
          const fourInARowSpotTwo = `<td width="50%" align="center" valign="top">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
            </tr>
          </tbody></table>
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
              </td>
            </tr>
          </tbody></table>
        </td>

      </tr>
    </tbody></table>
    <!--[if mso]>
    </td>
    <td align="left" valign="top">
    <![endif]-->`;
          const fourInARowSpotThree = `<table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody><tr>

            <td width="50%" align="center" valign="top">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
                </tr>
              </tbody></table>
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                    <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
                  </td>
                </tr>
              </tbody></table>
            </td>`;
          const fourInARowSpotFour = `<td width="50%" align="center" valign="top">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
            </tr>
          </tbody></table>
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
              </td>
            </tr>
          </tbody></table>
        </td>

      </tr>
    </tbody></table>
  </td>
</tr>
</tbody></table>
</td>
</tr>
</tbody></table>`;
          let threeInARowSpotOne = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody><tr>
            <td class="paddingRightLeft10" align="center" valign="top">
              <table class="widthFull" width="580" style="width:580px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="left" valign="top">
                    <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                      <tbody><tr>
        
                        <td width="50%" align="center" valign="top">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
                            </tr>
                          </tbody></table>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
                              </td>
                            </tr>
                          </tbody></table>
                        </td>`;
          let threeInARowSpotTwo = `                <td width="50%" align="center" valign="top">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
            </tr>
          </tbody></table>
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
              </td>
            </tr>
          </tbody></table>
        </td>

      </tr>
    </tbody></table>
    <!--[if mso]>
    </td>
    <td align="left" valign="top">
    <![endif]-->`;
          let threeInARowSpotThree = `            <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody><tr>

            <td width="50%" align="center" valign="top">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
                </tr>
              </tbody></table>
              <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                    <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
                  </td>
                </tr>
              </tbody></table>
            </td>

            <td width="50%" align="center" valign="top" style="height:20px; font-size:0; line-height:1px;">&nbsp;</td>

          </tr>
        </tbody></table>
      </td>
    </tr>
  </tbody></table>
</td>
</tr>
</tbody></table>`;
          let twoInARowSpotOne = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody><tr>
            <td class="paddingRightLeft10" align="center" valign="top">
              <table class="widthFull" width="580" style="width:580px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="left" valign="top">
                    <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                      <tbody><tr>
        
                        <td width="50%" align="center" valign="top">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
                            </tr>
                          </tbody></table>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
                              </td>
                            </tr>
                          </tbody></table>
                        </td>`;
          let twoInARowSpotTwo = `                <td width="50%" align="center" valign="top">
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
            </tr>
          </tbody></table>
          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
            <tbody><tr>
              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
              </td>
            </tr>
          </tbody></table>
        </td>

      </tr>
    </tbody></table>
    <!--[if mso]>
    </td>
    <td align="left" valign="top">
    <![endif]-->
    <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
      <tbody><tr>

        <td class="hidden" width="50%" align="center" valign="top" style="height:20px; font-size:0; line-height:1px;">&nbsp;</td>

        <td class="hidden" width="50%" align="center" valign="top" style="height:20px; font-size:0; line-height:1px;">&nbsp;</td>

      </tr>
    </tbody></table>
  </td>
</tr>
</tbody></table>
</td>
</tr>
</tbody></table>`;
          let oneInARow = `<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
          <tbody><tr>
            <td class="paddingRightLeft10" align="center" valign="top">
              <table class="widthFull" width="580" style="width:580px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody><tr>
                  <td align="left" valign="top">
                    <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                      <tbody><tr>
        
                        <td width="50%" align="center" valign="top">
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="60" border="0" style="display:block;"></a></td>
                            </tr>
                          </tbody></table>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                            <tbody><tr>
                              <td align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; mso-line-height-rule:exactly; line-height:18px; color:#0F475C; padding:0 10px 25px 10px;">
                                <strong><a href="${theAnchorLink}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theName}</a></strong>
                              </td>
                            </tr>
                          </tbody></table>
                        </td>
        
                        <td width="50%" align="center" valign="top" style="height:20px; font-size:0; line-height:1px;">&nbsp;</td>
        
                      </tr>
                    </tbody></table>
                    <!--[if mso]>
                    </td>
                    <td align="left" valign="top">
                    <![endif]-->
                    <table align="left" class="widthFull" width="290" style="width:290px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                      <tbody><tr>
        
                        <td class="hidden" width="50%" align="center" valign="top" style="height:20px; font-size:0; line-height:1px;">&nbsp;</td>
        
                        <td class="hidden" width="50%" align="center" valign="top" style="height:20px; font-size:0; line-height:1px;">&nbsp;</td>
        
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
              </tbody></table>
            </td>
          </tr>
        </tbody></table>`;
          // if all eight icons
          if (categoryIconTotal === 8) {
            // console.log("eight icons");
            if (categoryIconCount === 1 || categoryIconCount === 5) {
              categoryIconCount++;
              return fourInARowSpotOne;
            } else if (categoryIconCount === 4 || categoryIconCount === 8) {
              categoryIconCount++;
              return fourInARowSpotFour;
            } else if (categoryIconCount === 2 || categoryIconCount === 6) {
              categoryIconCount++;
              return fourInARowSpotTwo;
            } else if (categoryIconCount === 3 || categoryIconCount === 7) {
              categoryIconCount++;
              return fourInARowSpotThree;
            }
          } else if (categoryIconTotal === 7) {
            // console.log("seven icons");
            if (categoryIconCount === 1) {
              categoryIconCount++;
              return fourInARowSpotOne;
            } else if (categoryIconCount === 2) {
              categoryIconCount++;
              return fourInARowSpotTwo;
            } else if (categoryIconCount === 3) {
              categoryIconCount++;
              return fourInARowSpotThree;
            } else if (categoryIconCount === 4) {
              categoryIconCount++;
              return fourInARowSpotFour;
            } else if (categoryIconCount === 5) {
              categoryIconCount++;
              return threeInARowSpotOne;
            } else if (categoryIconCount === 6) {
              categoryIconCount++;
              return threeInARowSpotTwo;
            } else {
              categoryIconCount++;
              return threeInARowSpotThree;
            }
          } else if (categoryIconTotal === 6) {
            // console.log("six icons");
            if (categoryIconCount === 1) {
              categoryIconCount++;
              return fourInARowSpotOne;
            } else if (categoryIconCount === 2) {
              categoryIconCount++;
              return fourInARowSpotTwo;
            } else if (categoryIconCount === 3) {
              categoryIconCount++;
              return fourInARowSpotThree;
            } else if (categoryIconCount === 4) {
              categoryIconCount++;
              return fourInARowSpotFour;
            } else if (categoryIconCount === 5) {
              categoryIconCount++;
              return twoInARowSpotOne;
            } else {
              categoryIconCount++;
              return twoInARowSpotTwo;
            }
            // if (categoryIconCount === 1 || categoryIconCount === 4) {
            //   categoryIconCount++;
            //   return threeInARowSpotOne;
            // } else if (categoryIconCount === 2 || categoryIconCount === 5) {
            //   categoryIconCount++;
            //   return threeInARowSpotTwo;
            // } else if (categoryIconCount === 3 || categoryIconCount === 6) {
            //   categoryIconCount++;
            //   return threeInARowSpotThree;
            // }
          } else if (categoryIconTotal === 5) {
            // console.log("five icons");
            if (categoryIconCount === 1) {
              categoryIconCount++;
              return fourInARowSpotOne;
            } else if (categoryIconCount === 2) {
              categoryIconCount++;
              return fourInARowSpotTwo;
            } else if (categoryIconCount === 3) {
              categoryIconCount++;
              return fourInARowSpotThree;
            } else if (categoryIconCount === 4) {
              categoryIconCount++;
              return fourInARowSpotFour;
            } else {
              categoryIconCount++;
              return oneInARow;
            }
          } else if (categoryIconTotal === 4) {
            console.log("four icons");
            if (categoryIconCount === 1) {
              categoryIconCount++;
              return fourInARowSpotOne;
            } else if (categoryIconCount === 2) {
              categoryIconCount++;
              return fourInARowSpotTwo;
            } else if (categoryIconCount === 3) {
              categoryIconCount++;
              return fourInARowSpotThree;
            } else {
              categoryIconCount++;
              return fourInARowSpotFour;
            }
          } else if (categoryIconTotal === 3) {
            // console.log("three icons");
            if (categoryIconCount === 1) {
              categoryIconCount++;
              return threeInARowSpotOne;
            } else if (categoryIconCount === 2) {
              categoryIconCount++;
              return threeInARowSpotTwo;
            } else {
              categoryIconCount++;
              return threeInARowSpotThree;
            }
          } else if (categoryIconTotal === 2) {
            if (categoryIconCount === 1) {
              categoryIconCount++;
              return twoInARowSpotOne;
            } else {
              categoryIconCount++;
              return twoInARowSpotTwo;
            }
          } else {
            return oneInARow;
          }
          // (categoryIconCount < 4) ?
          //   (
          //     ``
          //   ) : (
          //     ``
          //   );
          // let articleCount =countArticlesInFeed(0);
          // console.log(feeds[0].articleCount);
          // console.log("is a category menu feed!");
        } else if (post.hidden !== true && !isEvents) {
          // console.log(post.acf.fl_article_url);
          const theInstitution = post.acf.fl_institution_shortname
            ? post.acf.fl_institution_shortname
            : "Institution Short Name";
          const theTitle = post.title.rendered;
          const theUrl = post.acf.fl_article_url ? post.acf.fl_article_url : post.link;
          const theImgUrl = post._embedded["wp:featuredmedia"]
            ? post._embedded["wp:featuredmedia"][0].source_url
            : "";
          if (withExcerpt) {
            // HTML block for ASPPH News
            if (aspphNewsCount === 1) {
              console.log("My object: ", post);
              aspphNewsCount = aspphNewsCount + 1;
              return `
              <table class="wrapper_ia" align="center" style="width: 600px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" width="600" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td valign="top" align="center" class="aside15_ia" style="border-collapse: collapse;mso-line-height-rule: exactly;"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;">
                    <tr>
                      <td align="center" class="defaultlink_ia txt_white_ia ptop_ia pbottom_ia" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 28px;font-weight: 600;line-height: 32px;color: #3D4F5D;padding-top: 10px;padding-bottom: 26px;border-collapse: collapse;mso-line-height-rule: exactly;" valign="top">ASPPH NEWS</td>
                    </tr>
                  </table></td>
              </tr>
              <tr>
                <td class="full_img_ia" style="padding-bottom: 10px;border-collapse: collapse;mso-line-height-rule: exactly;" align="center" valign="top"><img src="${theImgUrl}" alt="" border="0" style="margin: 0;padding: 0;display: block;max-width: 600px;font-family: Arial, sans-serif;font-size: 20px;line-height: 25px;color: #000000;font-weight: bold;border: 0 !important;outline: none !important;" width="600"></td>
              </tr>
            </table>
              <table class="wrapper_ia" align="center" style="width: 600px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" width="600" border="0" cellspacing="0" cellpadding="0" mc:repeatable="repeat_1" mc:variant="Text Only" mc:repeatindex="0">
                <tr>
                  <td valign="top" align="center" class="aside15_ia" style="border-collapse: collapse;mso-line-height-rule: exactly;"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;">
                      <tr>
                      <td align="left" class="defaultlink_ia txt_white_ia" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;font-weight: bold;line-height: 22px;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" valign="top"><span style="font-size: 20px;border-collapse: collapse;mso-line-height-rule: exactly;"><a href="${theUrl}" style="text-decoration: none;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" target="_blank"><strong>${post.title.rendered}</strong></a></span><br>
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td align="left" class="defaultlink_ia txt_white_ia" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;padding-bottom: 25px;line-height: 22px;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" valign="top">${post.content.rendered}</td>
                      </tr>
                    </table>
                    </td>
                </tr>
              </table>
              <table class="wrapper_ia" align="center" style="width: 600px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" width="600" border="0" cellspacing="0" cellpadding="0" mc:repeatable="repeat_1" mc:variant="CTA" mc:repeatindex="3">
              <tr>
                <td valign="top" align="center" style="padding: 0px 15px 25px;border-collapse: collapse;mso-line-height-rule: exactly;"><table class="wrapper_ia" border="0" cellspacing="0" cellpadding="0" align="center" style="border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;">
                    <tr>
                      <td class="defaultlink_ia" align="center" valign="middle" height="40" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;color: #ffffff;font-weight: 600;height: 40px;padding: 0px 25px;border-collapse: collapse;mso-line-height-rule: exactly;" bgcolor="#f85f26"><a href="${theUrl}" style="text-decoration: none;color: #ffffff;display: block;line-height: 40px;border-collapse: collapse;mso-line-height-rule: exactly;" target="_blank">LEARN MORE &nbsp;<img height="9" src="https://mcusercontent.com/126f4b87a0f510d613477a97b/images/bd62fa26-f832-7787-f79b-4ac4e948a8e7.png" style="display: inline-block;border: none;max-width: 8px;outline: none !important;" width="8"></a></td>
                    </tr>
                  </table></td>
              </tr>
            </table>`;
            }
            if (aspphNewsCount > 1) {
              aspphNewsCount = aspphNewsCount + 1;
              return `<table class="wrapper_ia" align="center" style="width: 600px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" width="600" border="0" cellspacing="0" cellpadding="0" mc:repeatable="repeat_1" mc:variant="Text Only" mc:repeatindex="1">
              <tr>
                <td valign="top" align="center" class="aside15_ia" style="border-collapse: collapse;mso-line-height-rule: exactly;"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;">
                    <tr>
                      <td align="left" class="defaultlink_ia txt_white_ia" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;font-weight: bold;line-height: 22px;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" valign="top"><a href="${theUrl}" style="text-decoration: none;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" target="_blank"><span style="font-size: 20px;border-collapse: collapse;mso-line-height-rule: exactly;"><strong>${post.title.rendered}</strong></span></a></td>
                    </tr>
                    <tr>
                      <td align="left" class="defaultlink_ia txt_white_ia" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;padding-bottom: 0px;line-height: 22px;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" valign="top"></td>
                    </tr>
                  </table></td>
              </tr>
            </table><table class="wrapper_ia" align="center" style="width: 600px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" width="600" border="0" cellspacing="0" cellpadding="0" mc:repeatable="repeat_1" mc:variant="Two Column - Text/Image" mc:repeatindex="2">
              <tr>
                <td valign="top" align="center" class="aside15_ia pbottom_ia" style="padding-bottom: 25px;border-collapse: collapse;mso-line-height-rule: exactly;"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;">
                    <tr>
                      <td valign="top" align="center" style="border-collapse: collapse;mso-line-height-rule: exactly;"><table align="right" style="width: 200px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" class="wrapper_ia" width="200" border="0" cellspacing="0" cellpadding="0">
                          <tr>
                            <td class="full_img_ia2 pbottom_ia" align="center" valign="top" style="border-collapse: collapse;mso-line-height-rule: exactly;"><img src="${theImgUrl}" alt="" border="0" style="margin: 0;padding: 0;display: block;max-width: 200px;font-family: Arial, sans-serif;font-size: 20px;line-height: 25px;color: #000000;font-weight: bold;border: 0 !important;outline: none !important;" width="200"></td>
                          </tr>
                        </table>
                        <table align="left" style="width: 375px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" class="wrapper_ia" width="375" border="0" cellspacing="0" cellpadding="0">
                        
                          <tr>
                            <td align="left" class="defaultlink_ia txt_white_ia " style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;line-height: 22px;color: #3D4F5D;border-collapse: collapse;mso-line-height-rule: exactly;" valign="top">${post.excerpt.rendered}</td>
                          </tr>
                        </table></td>
                    </tr>
                  </table></td>
              </tr>
            </table>
            <table class="wrapper_ia" align="center" style="width: 600px;border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;" width="600" border="0" cellspacing="0" cellpadding="0" mc:repeatable="repeat_1" mc:variant="CTA" mc:repeatindex="3">
              <tr>
                <td valign="top" align="center" style="padding: 0px 15px 25px;border-collapse: collapse;mso-line-height-rule: exactly;"><table class="wrapper_ia" border="0" cellspacing="0" cellpadding="0" align="center" style="border-collapse: collapse;mso-table-lspace: 0px;mso-table-rspace: 0px;">
                    <tr>
                      <td class="defaultlink_ia" align="center" valign="middle" height="40" style="font-family: 'Source Sans Pro', Arial, sans-serif;font-size: 16px;color: #ffffff;font-weight: 600;height: 40px;padding: 0px 25px;border-collapse: collapse;mso-line-height-rule: exactly;" bgcolor="#f85f26"><a href="${theUrl}" style="text-decoration: none;color: #ffffff;display: block;line-height: 40px;border-collapse: collapse;mso-line-height-rule: exactly;" target="_blank">LEARN MORE &nbsp;<img height="9" src="https://mcusercontent.com/126f4b87a0f510d613477a97b/images/bd62fa26-f832-7787-f79b-4ac4e948a8e7.png" style="display: inline-block;border: none;max-width: 8px;outline: none !important;" width="8"></a></td>
                    </tr>
                  </table></td>
              </tr>
            </table>`;
            }
          } else if (post.categories.includes(8) || post.categories.includes(4)) {
            // HTML block for School and Programs OR Global Action
            let leftOrRight = "left";
            if (post.categories.includes(8)) {
              leftOrRight = schoolProgCount % 2 === 0 ? "right" : "left";
              schoolProgCount++;
            } else if (post.categories.includes(4)) {
              leftOrRight = studentAlumniCount % 2 === 0 ? "right" : "left";
              studentAlumniCount++;
            }
            if (leftOrRight === "left") {
              return `<table dir="rtl" class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody>
                  <tr>
                    <td align="left" valign="top">
                      <table dir="ltr" align="right" class="widthFull" width="200" style="width:200px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                        <tbody><tr>
                          <td class="paddingRightLeft20 paddingBottom10" align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 25px 0;"><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="200" border="0" style="display:block;" class="photo"></a></td>
                        </tr>
                      </tbody></table>
                      <!--[if mso]>
                      </td>
                      <td align="left" valign="top">
                      <![endif]-->
                      <table dir="ltr" align="left" class="widthFull" width="400" style="width:400px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                        <tbody><tr>
                          <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:0 25px 25px 0;">
                            <span style="color:#F85F26; font-weight: bold;">${theInstitution}</span>
                            <br>
                            <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                          </td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>
                </tbody>
              </table>`;
            } else if (leftOrRight === "right") {
              return `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                  <tbody><tr>
                    <td align="left" valign="top">
                      <table align="left" class="widthFull" width="200" style="width:200px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                        <tbody><tr>
                          <td class="paddingRightLeft20 paddingBottom10" align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 25px 0;"><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="200" border="0" style="display:block;" class="photo"></a></td>
                        </tr>
                      </tbody></table>
                      <!--[if mso]>
                      </td>
                      <td align="left" valign="top">
                      <![endif]-->
                      <table align="left" class="widthFull" width="400" style="width:400px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                        <tbody><tr>
                          <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:0 0 25px 25px;">
                            <span style="color:#F85F26; font-weight: bold;">${theInstitution}</span>
                            <br>
                            <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                          </td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>
                </tbody>
              </table>`;
            }
          } else if (post.categories.includes(6) || post.categories.includes(5)) {
            // HTML block for Members in the News OR Member Research & Reports
            return `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody>
                  <tr>
                    <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:0 0 25px 0;">
                      <span style="color:#F85F26; font-weight: bold;">${theInstitution}</span>
                      <br>
                      <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                    </td>
                  </tr>
                </tbody>
              </table>`;
          } else if (post.categories.includes()) {
            // HTML block for two column (with one at top if odd)
            let hasOddNumber;
            let isFirst = true;
            let evenOrOdd = "odd";
            if (post.categories.includes(4)) {
              hasOddNumber = feeds[3].articleCount % 2 === 0;
              isFirst = globalActionCount === 1 ? true : false;
              evenOrOdd = globalActionCount % 2 === 0 ? "even" : "odd";
              globalActionCount++;
            } else if (post.categories.includes(3)) {
              hasOddNumber = feeds[5].articleCount % 2 !== 0;
              isFirst = facultyStaffCount === 1 ? true : false;
              evenOrOdd = facultyStaffCount % 2 === 0 ? "even" : "odd";
              facultyStaffCount++;
            }
            if (hasOddNumber && isFirst) {
              return `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                  <tbody>
                    <tr>
                      <td class="paddingRightLeft20" align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="600" border="0" style="display:block;" class="photo"></a></td>
                    </tr>
                  </tbody>
                </table>
                <table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                  <tbody>
                    <tr>
                      <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:0 0 25px 0;">
                        <span style="color:#F85F26; font-weight: bold;">${theInstitution}</span>
                        <br>
                        <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                      </td>
                    </tr>
                  </tbody>
                </table>`;
            } else if (
              (hasOddNumber && evenOrOdd === "even") ||
              (!hasOddNumber && evenOrOdd === "odd")
            ) {
              return `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                <tbody>
                  <tr>
                    <td align="left" valign="top">
                      <table align="left" class="widthFull" width="320" style="width:320px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                        <tbody>
                          <tr>
                            <td align="left" valign="top">
                              <table class="widthFull" width="280" style="width:280px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                                <tbody>
                                  <tr>
                                    <td class="paddingRightLeft20" align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="280" border="0" style="display:block;" class="photo"></a></td>
                                  </tr>
                                  <tr>
                                    <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:0 0 25px 0;">
                                      <span style="color:#F85F26;">${theInstitution}</span>
                                      <br>
                                      <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!--[if mso]>
                      </td>
                      <td align="left" valign="top">
                      <![endif]-->`;
            } else if (
              (hasOddNumber && evenOrOdd === "odd") ||
              (!hasOddNumber && evenOrOdd === "even")
            ) {
              return `<table align="left" class="widthFull" width="280" style="width:280px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
                        <tbody>
                          <tr>
                            <td class="paddingRightLeft20" align="center" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:0 0 10px 0;"><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="280" border="0" style="display:block;" class="photo"></a></td>
                          </tr>
                          <tr>
                            <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:0 0 25px 0;">
                              <span style="color:#F85F26; font-weight: bold;">${theInstitution}</span>
                              <br>
                              <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>`;
            }
          } else if (post.categories.includes(9) || post.categories.includes(3)) {
            // HTML block for Student & Alumni Achievements OR Faculty & Staff
            return `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tr>
                <td class="paddingRightLeft20" align="center" valign="top" style="padding:0 0 25px 0;">
                  <table bgcolor="#EDEFF1" width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
                    <tr>
                      <td bgcolor="#A6A8AF" width="5" align="left" valign="top" style="width:5px; font-size:0; line-height:1px;">&nbsp;</td>
                      <td width="20" align="left" valign="top" style="width:20px; font-size:0; line-height:1px;">&nbsp;</td>
                      <td width="100" align="center" valign="middle" style="width:100px; font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:14px; color:#3D4F5D; padding:15px 0 15px 0;"><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:underline;"><img src="${theImgUrl}" alt="" width="100" border="0" style="display:block;" /></a></td>
                      <td align="left" valign="middle" style="font-family:'Source Sans Pro', Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#3D4F5D; padding:15px 25px 15px 20px;">
                        <span style="color:#F85F26; font-weight: bold;">${theInstitution}</span>
                        <br />
                        <strong><a href="${theUrl}" target="_blank" style="color:#3D4F5D; text-decoration:none;">${theTitle}</a></strong>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>`;
          } else if (post.categories.includes(7)) {
            // HTML block for Partner News
            return `<table class="widthFull" width="600" style="width:600px;" cellpadding="0" cellspacing="0" border="0" role="presentation">
              <tbody><tr>
                <td class="paddingRightLeft20" align="left" valign="top" style="font-family:&#39;Source Sans Pro&#39;, Helvetica, sans-serif; font-size:16px; mso-line-height-rule:exactly; line-height:22px; color:#FFFFFE; padding:0 0 25px 0;">
                  <span style="font-weight: bold;">${theInstitution}</span>
                  <br>
                  <strong><a href="${theUrl}" target="_blank" style="color:#FFFFFE; text-decoration:none;">${theTitle}</a></strong>
                </td>
              </tr>
            </tbody></table>`;
          }
        } else if (post.hidden !== true && isEvents) {
          const theInstitution = post.organizer ? post.organizer[0] : "Institution Short Name";
          const theTitle = post.title;
          // const theUrl = post.website;
          const theImgUrl = post.image.url ? post.image.url : "";
          const monthNumber = parseInt(post.start_date_details.month);
          function monthName(monthNumber) {
            return [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ][monthNumber - 1];
          }
          const dateMonth = monthName(monthNumber);
          const dateDay = post.start_date_details.day;
          const dateYear = post.start_date_details.year;
          const hourNumber = parseInt(post.start_date_details.hour);
          const dateHour = hourNumber > 12 ? hourNumber % 12 : hourNumber;
          const dateMinute = post.start_date_details.minutes;
          const amOrPm =
            post.start_date_details.hour < 12 || post.start_date_details.hour === 24 ? "AM" : "PM";
          const theDate =
            hourNumber === 0
              ? `${dateMonth} ${dateDay}, ${dateYear}`
              : `${dateMonth} ${dateDay}, ${dateYear} ${dateHour}:${dateMinute} ${amOrPm} ET`;
          return ``;
          // Events not included in newsletter for now
        } else {
          return "";
        }
      })
      .join("");
    // }
    // console.log(articleHtmlStrings);
    return articleHtmlStrings;
  };

  const onSortEnd = ({ oldIndex, newIndex, collection }) => {
    let newFeeds = [...feeds];
    newFeeds[collection].results = arrayMove(newFeeds[collection].results, oldIndex, newIndex);
    newFeeds[collection].htmlString = buildHtmlString(
      newFeeds[collection].results,
      newFeeds[collection].showExcerpt
    );
    let feedTotals = feeds.forEach((feed, index) => {
      countArticlesInFeed(index);
    });
    setFeeds(newFeeds);
  };

  const handleHideClick = (feedIndex, currentIndex) => {
    let newFeeds = [...feeds];
    const newValue = newFeeds[feedIndex].results[currentIndex].hidden === true ? false : true;
    newFeeds[feedIndex].results[currentIndex].hidden = newValue;
    // Send to bottom of list if hiding
    if (newValue === true) {
      newFeeds[feedIndex].results = arrayMove(newFeeds[feedIndex].results, currentIndex, -1);
    }
    newFeeds[feedIndex].htmlString = buildHtmlString(
      newFeeds[feedIndex].results,
      newFeeds[feedIndex].showExcerpt
    );
    let feedTotals = feeds.forEach((feed, index) => {
      countArticlesInFeed(index);
    });
    setFeeds(newFeeds);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const baseUrl = "https://www.aspph.org/wp-json/wp/v2";

    // Make calls out to API to find tag ID
    const result = await axios.get(`${baseUrl}/tags?search=${encodeURIComponent(tags)}`);
    // console.log(result);

    if (result.data && result.data.length > 0) {
      const tagIds = result.data.map((t) => t.id).join(",");
      // auto apply the Friday Letter Newsletter tag
      const flNewsletterTagId = 472;
      setFormErrors("");

      // Make all calls for the feeds
      feeds.forEach(async (feed, index) => {
        if (feed.isEvents === true) {
          // console.log("event logged!");
          const baseEventUrl = "https://www.aspph.org/wp-json/tribe/events/v1/events";
          const feedUrl =
            tags === ""
              ? `${baseEventUrl}?per_page=100&_embed`
              : `${baseEventUrl}?tags=${tagIds}&per_page=100&_embed`;
          const feedResult = await axios.get(feedUrl);
          // console.log("feedResult", feedResult.data.events);
          let newFeeds = [...feeds];
          // console.log(newFeeds);
          newFeeds[index].results = feedResult.data.events;
          newFeeds[index].htmlString = buildHtmlString(
            newFeeds[index].results,
            false,
            newFeeds[index].isEvents
          );
          countArticlesInFeed(index);
          setFeeds(newFeeds);
        } else if (feed.isCategories === true) {
          let newFeeds = [...feeds];
          newFeeds[index].results = [
            {
              name: "ASPPH News",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/18b07c7a-2c68-4e9f-3a7b-9078c0bed8cb.png",
              anchorLink: "#ASPPHNews",
            },
            {
              name: "School &amp; Program<br> Updates",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/58e91e78-2f70-f31b-9b2b-16ddc3983af8.png",
              anchorLink: "#SchoolAndProgramUpdates",
            },
            {
              name: "Members in<br> the&nbsp;News",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/f59a1a1f-7de6-46bc-27b7-f2ad43aa9fdf.png",
              anchorLink: "#MembersInTheNews",
            },
            {
              name: "Global Action",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/16b1b60d-27b5-5057-f0ff-f494827440e8.png",
              anchorLink: "#GlobalAction",
            },
            {
              name: "Member Research<br> &amp;&nbsp;Reports",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/cee29d55-80f2-8627-845b-e1e24ceccc9a.png",
              anchorLink: "#MemberResearchAndReports",
            },
            {
              name: "Faculty &amp;<br> Staff&nbsp;Honors",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/1c054f77-1027-42d2-2299-126fd7152767.png",
              anchorLink: "#FacultyAndStaffHonors",
            },
            {
              name: "Student &amp; Alumni<br> Achievements",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/3a0d4ff8-7a3c-9f58-edee-5e1743082b8a.png",
              anchorLink: "#StudentAndAlumniAchievements",
            },
            {
              name: "Partner News",
              categoryId: "category",
              imgUrl:
                "https://mcusercontent.com/126f4b87a0f510d613477a97b/images/49308d3c-e3b4-951c-0ae0-5812ca5c40c0.png",
              anchorLink: "#PartnerNews",
            },
          ];
          newFeeds[index].htmlString = buildHtmlString(
            newFeeds[index].results,
            false,
            false,
            newFeeds[index].isCategories
          );
          countArticlesInFeed(index);
          setFeeds(newFeeds);
        } else {
          const feedUrl =
            tags === ""
              ? `${baseUrl}/posts?categories=${feed.categoryId}&per_page=100&_embed`
              : `${baseUrl}/posts?categories=${feed.categoryId}&tags=${tagIds}&per_page=100&_embed`;
          const feedResult = await axios.get(feedUrl);
          // console.log("feedResult", feedResult);
          let newFeeds = [...feeds];
          newFeeds[index].results = feedResult.data;
          newFeeds[index].htmlString = buildHtmlString(
            newFeeds[index].results,
            newFeeds[index].showExcerpt
          );
          countArticlesInFeed(index);
          setFeeds(newFeeds);
        }
        countArticlesInFeed(index);
      });
    } else {
      setFormErrors("No tags were found");
    }
  };

  return (
    <div className="App">
      <header className="App-header mb-4">
        <Navbar bg="dark" variant="dark">
          <Navbar.Brand href="/">Friday Letter Builder</Navbar.Brand>
        </Navbar>
      </header>

      <main>
        <Container fluid>
          <Row>
            <Col sm={8}>
              {formErrors && <Alert variant="danger">{formErrors}</Alert>}
              <Form onSubmit={handleSubmit} className="mb-4">
                <Form.Row>
                  <Col>
                    <Form.Control
                      onChange={(e) => setTags(e.target.value)}
                      value={tags}
                      type="text"
                      placeholder="Tag Name (e.g. For Friday Letter October 07 2022)"
                    />
                  </Col>
                  <Col>
                    <Button variant="primary" type="submit">
                      Load Feeds
                    </Button>
                  </Col>
                </Form.Row>
              </Form>
            </Col>
          </Row>
          <Row>
            {feeds.map((feed, index) => (
              <Col sm={4} key={feed.name}>
                <Feed
                  onSortEnd={onSortEnd}
                  name={feed.name}
                  categoryId={feed.categoryId}
                  items={feed.results}
                  articleCount={feed.articleCount}
                  htmlString={feed.htmlString}
                  feedIndex={index}
                  handleHideClick={handleHideClick}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </main>
    </div>
  );
}

export default App;
